/* eslint-disable camelcase */
/* eslint-disable spire/fenced-imports */
/* eslint-disable ordered-imports/ordered-imports */
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { css } from "styled-components";

export interface ProductListPaginationStyles {
    select?: SelectPresentationProps;
    perPageStyles?: InjectableCss;
}

export const paginationStyles: ProductListPaginationStyles = {
    select: {
        labelProps: {
            css: css`
                width: unset;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 325px;
                margin-right: 32px;
                label {
                    padding-top: 2px !important;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-right: 0px;
                        `,
                        css`
                            margin-right: 0px;
                        `,
                        css`
                            margin-right: 0px;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    perPageStyles: {
        css: css`
            display: inline-flex;
            > label {
                width: 76px;
                padding-right: 11px;
                display: inline-flex;
                align-items: center;
                color: ${ADIColors.darkBlack3};
                font-size: 14px;
                font-weight: 800;
            }
            > div[class^="FormFieldStyle"] {
                width: 73px;
                > div:first-of-type {
                    width: 0 !important;
                }
                > div[class^="FormInputWrapper"] {
                    > select {
                        width: 75px;
                    }
                    > span {
                        left: 35px;
                    }
                }
            }
        `,
    },
};

// const styles = paginationStyles;
// const pageSizeOptions = [12, 24, 36]; // Define the page size options
export const CoveoADIProductListPageSize = () => {

    // COMPONENT NOT CURRENTLY USED


    // const Location = useLocation();
    // const isSearchPage = Location.isPath("/search");

    // if (!coveoProductList || !coveoSearch || !paginationState) {
    //     return null;
    // }

    // const pagination = isSearchPage ? coveoSearch?.pagination() : coveoProductList?.pagination();
    // const setPageSize = pagination?.setPageSize
    // const currentPageSize = paginationState?.pageSize;

    // const changeResultsPerPage = (value: string) => {
    //     const pageSize = Number(value);
    //     // if not a number, return
    //     // eslint-disable-next-line no-restricted-globals
    //     if (isNaN(pageSize)) { return; }
    //     setPageSize(pageSize);
    // };

    // return (
    //     <StyledWrapper {...styles.perPageStyles}>
    //         <label htmlFor="pageSizeSelector">Per Page</label>
    //         <Select
    //             {...styles.select}
    //             value={currentPageSize}
    //             id="pageSizeSelector"
    //             labelPosition="left"
    //             onChange={({target}) => changeResultsPerPage(target.value)}
    //             data-test-selector="productListSortSelect"
    //         >
    //             {pageSizeOptions.map(option => (
    //                 <option key={option} value={option}>
    //                     {option}
    //                 </option>
    //             ))}
    //         </Select>
    //     </StyledWrapper>
    // );
    return null;
};

const widgetModule: WidgetModule = {
    component: CoveoADIProductListPageSize,
    definition: {
        group: "Product List",
        icon: "Image",
        displayName: "Coveo Product List Page Size",
        fieldDefinitions: [],
    },
};

export default widgetModule;
